module.exports = __webpack_public_path__ + "static/media/pending_redemption.577c3ac5.svg";